import React, { useEffect, useState } from 'react'
import UserService, { IUserModel } from '../../services/user'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { useDispatch } from 'react-redux'
import { updateSingleUser } from './userSlice'
import { handleRequestError } from '../../services/api'

interface IProps {
    user: IUserModel
}

export default function BanUserButton(props: IProps) {

    const dispatch = useDispatch()

    const { user } = props
    const [loading, setLoading] = useState<boolean>(false)

    const blockUser = () => {
        setLoading(true)

        UserService.banUser(user.id, user.is_banned ? true : false)
            .then(response => {

                const { data } = response
                const message = data.message ? data.message : "User has been banned"

                updateQuickNotificationDetails(true, message, "success", dispatch)

                dispatch(updateSingleUser({
                    ...user,
                    is_banned: user.is_banned ? false : true,
                    status: user.is_banned ? "active" : "banned"
                }))

                setLoading(false)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })
    }
    
    return <LoadingButton onClick={() => blockUser()} loading={loading} className="general-button admin-style light-button" variant="contained" color={user.is_banned ? "success" : "error"} >{user.is_banned ? "Unban User" : "Ban User"}</LoadingButton>
}